// Color classes for Autotask ticket status IDs. Tailwind requires the full
// class strings to appear literally in source — keep these as plain strings.
//
// IDs from /api/picklists status (Synfo Autotask instance):
//   1  New
//   5  Complete
//   7  Waiting Customer
//   8  In Progress
//   10 Assigned
//   19 Customer Note Added
//   20 Waiting Vendor
//   21 Complete-Pending Customer
//   22 Waiting Parts
//   23 Escalated
//   25 Scheduled
//   26 On-Hold

const STATUS_COLORS: Record<number, string> = {
  1:  'bg-blue-100 text-blue-900 dark:bg-blue-900/40 dark:text-blue-200',          // New
  5:  'bg-emerald-100 text-emerald-900 dark:bg-emerald-900/40 dark:text-emerald-200', // Complete
  7:  'bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-200',      // Waiting Customer
  8:  'bg-sky-100 text-sky-900 dark:bg-sky-900/40 dark:text-sky-200',              // In Progress
  10: 'bg-indigo-100 text-indigo-900 dark:bg-indigo-900/40 dark:text-indigo-200',  // Assigned
  19: 'bg-orange-100 text-orange-900 dark:bg-orange-900/40 dark:text-orange-200',  // Customer Note Added
  20: 'bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-200',      // Waiting Vendor
  21: 'bg-emerald-50 text-emerald-800 dark:bg-emerald-900/20 dark:text-emerald-300', // Complete-Pending Customer
  22: 'bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-200',      // Waiting Parts
  23: 'bg-red-100 text-red-900 dark:bg-red-900/40 dark:text-red-200',              // Escalated
  25: 'bg-purple-100 text-purple-900 dark:bg-purple-900/40 dark:text-purple-200',  // Scheduled
  26: 'bg-zinc-200 text-zinc-700 dark:bg-zinc-700/50 dark:text-zinc-300',          // On-Hold
};

const FALLBACK = 'bg-secondary text-secondary-foreground';

export function statusColor(id: number | null | undefined): string {
  if (id == null) return FALLBACK;
  return STATUS_COLORS[id] ?? FALLBACK;
}

// Priority colors. Autotask default priority IDs (commonly):
//   1 Critical, 2 High, 3 Medium, 4 Low
const PRIORITY_COLORS: Record<number, string> = {
  1: 'bg-red-100 text-red-900 dark:bg-red-900/40 dark:text-red-200',
  2: 'bg-orange-100 text-orange-900 dark:bg-orange-900/40 dark:text-orange-200',
  3: 'bg-amber-100 text-amber-900 dark:bg-amber-900/40 dark:text-amber-200',
  4: 'bg-sky-100 text-sky-900 dark:bg-sky-900/40 dark:text-sky-200',
};

export function priorityColor(id: number | null | undefined): string {
  if (id == null) return FALLBACK;
  return PRIORITY_COLORS[id] ?? FALLBACK;
}
